<template>
    <div v-if="view">
        <h3 class="custom-font-h mt-0 mb-1">IC Service</h3>
        <h5 class="text-lowercase text-muted custom-font-h mt-0 mb-2">Please click the Create Ticket button to let us know how we can help you.</h5>
        <div class="row mb-2 mt-3">
            <div class="col-md-6">
                <button
                    @click="openAddRequest" 
                    type="button" 
                    class="mt-0 mr-2 btn btn-warning text-dark font-en"
                >
                    <b><i class="fa fa-pencil-square-o fa-lg mr-1"></i>Create Ticket</b>
                </button>
            </div>
        </div>
        <div class="row mb-2 mt-3">
            <div 
                class="mb-3"
                :class="{'col-md-4 ': MaxScale === 'Monitor','col-md-12': MaxScale === 'miniMonitor'}" 
            >
                <b-card>
                    <h4 style="font-weight:100;margin-bottom: 0px;" class="font-en mt-2">
                        <span class="border-w mr-2"></span>Open
                    </h4>
                    <div id="style-4" style="max-height:500px;overflow:auto;">
                        <b-table
                            class="mt-0"
                            small show-empty borderless striped responsive="sm"
                            :items="itemsWait"
                            :fields="fieldsWait"
                            ref="selectableTable1"
                            selectable
                            select-mode="single"
                            @row-selected="onRowSelected"
                        >
                            <template v-slot:cell(list)="row">
                                <h5 class="mt-0 mb-0">
                                    <span class="mr-1">Query : {{ zeroPad(row.item.no) }}</span>
                                    <small><b-badge class="text-capitalize" v-if="row.item.user_read === 'unseen'" variant="success">Update</b-badge></small> 
                                </h5>
                                <p style="font-size:0.8rem;" class="font-thai mb-0">
                                    <span class="d-inline-block text-truncate" style="max-width: 250px;">{{ row.item.listService }}</span> 
                                </p>
                                <small class="mt-0 font-en text-muted">
                                    <b-badge style="font-weight:100;" class="font-en mr-1" :class="{ 'bg-info': row.item.status === 'accept' , 'bg-warning': row.item.status === 'wait' }">
                                        {{ row.item.status === 'accept' ? 'in progress' : ''}}
                                        {{ row.item.status === 'wait' ? 'open' : ''}}
                                    </b-badge> 
                                    <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                    {{ moment(row.item.created_at).format('LLL') }}
                                    <i class="fa fa-tag" aria-hidden="true"></i>{{ row.item.jobtype }} 
                                </small>
                            </template>
                        </b-table>
                    </div>
                    <h4 style="font-weight:100;margin-bottom: 0px;" class="font-en mt-3">
                        <span class="border-s mr-2"></span>Closed
                    </h4>
                    <div id="style-4" style="max-height:500px;overflow:auto;">
                        <b-table
                            class="mt-0"
                            small show-empty borderless striped responsive="sm"
                            :items="itemsSuccess"
                            :fields="fieldsSuccess" 
                            ref="selectableTable2"
                            selectable
                            select-mode="single"
                            @row-selected="onRowSelected_2"
                        >
                            <template v-slot:cell(list)="row">
                                <h5 class="mt-0 mb-0">
                                    Query : {{ zeroPad(row.item.no) }}
                                    <small><b-badge class="text-capitalize" v-if="row.item.ticketpoint === null && row.item.ticketcomment === null && row.item.status !== 'cancel'" variant="warning">Please Vote</b-badge></small> 
                                </h5>
                                <p style="font-size:0.8rem;" class="font-thai mb-0">
                                    <span class="d-inline-block text-truncate" style="max-width: 250px;">{{ row.item.listService }}</span> 
                                </p>
                                <small class="mt-0 font-en text-muted">
                                    <b-badge style="font-weight:100;" class="font-en mr-1" :class="{ 'bg-success': row.item.status === 'success' , 'bg-dark': row.item.status === 'cancel'}">
                                        {{ row.item.status === 'success' ? 'success' : ''}}
                                        {{ row.item.status === 'cancel' ? 'canceled' : ''}}
                                    </b-badge>
                                    <i class="fa fa-calendar-o" aria-hidden="true"></i>
                                    {{ moment(row.item.created_at).format('LLL') }}
                                    <i class="fa fa-tag" aria-hidden="true"></i>{{ row.item.jobtype }}
                                </small>
                            </template>
                        </b-table>
                    </div>
                </b-card>
            </div>
            <div v-if="contentShow" class="col-md-8 mb-2">
                <b-card header-bg-variant="dark" header-text-variant="light">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h4 style="font-weight:100;" class="font-en mt-0 mb-0"><i class="fa fa-ticket mr-2" aria-hidden="true"></i>Your Query No. {{ solutionId }}</h4>
                        <div>
                            <div v-if="solutionStaus === 'wait' && !EditForm">
                                <b-button class="text-capitalize mt-0 mb-2" @click="changeEditForm" size="sm" variant="info"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>Edit Query</b-button>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div v-if="EditForm">
                        <b-row class="my-0">
                            <b-col sm="10">
                                <b-form class="mt-0">
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Topic</label>
                                        </b-col>
                                        <b-col class="font-thai" sm="8">{{ solutionTopic }}</b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Category</label>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-select
                                                :options="optionsSelectProblem"
                                                v-model="formData.typeProblem"
                                                class="font-thai"
                                                autocomplete="off" trim
                                            >
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Email</label>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-group
                                                description="Please enter a valid email address so our staff can reach you."
                                            >
                                                <b-form-input
                                                    class="font-thai"
                                                    type="email"
                                                    placeholder="Enter email"
                                                    autocomplete="off" trim
                                                    v-model="formData.mailContact"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4">
                                            <label><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Phone number</label>
                                        </b-col>
                                        <b-col sm="8">
                                            <b-form-group
                                                invalid-feedback="Bad Mobile Phone format"
                                                description="Please enter your telephone number ex: 0800547169"
                                            >
                                                <b-form-input
                                                    size="sm"
                                                    class="font-thai"
                                                    maxlength="10"
                                                    type="text"
                                                    placeholder="Enter Phone number"
                                                    autocomplete="off" trim
                                                    v-model="formData.phoneContact"
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="my-0">
                                        <b-col sm="4"></b-col>
                                        <b-col sm="8">
                                            <b-button block class="text-capitalize mt-0 mb-2" @click="updateTicketData(solutionId)" size="sm" variant="success"><i class="fa fa-paper-plane" aria-hidden="true"></i>Submit</b-button>
                                            <b-button block class="text-capitalize mt-0 mb-2" @click="EditForm = !EditForm" size="sm" variant="warning"><i class="fa fa-reply" aria-hidden="true"></i>Back</b-button>
                                            <hr>
                                            <b-button block class="text-capitalize" @click="cancelCase(solutionId)" size="sm" variant="danger">
                                                <i class="fa fa-times" aria-hidden="true"></i>Delete Query
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <div v-for="(item, index) in dataComment" :key="index">
                            <b-card
                                class="mb-2 mt-0"
                                :class="{ 'bordercolorCustom' : solutiononwercase !== item.user , 'bg-light' : solutiononwercase === item.user }"
                            >
                                <b-card-text >
                                    <b-media>
                                        <template v-slot:aside>
                                            <img v-if="solutiononwercase === item.user" class="rounded" src="@/assets/img/icon_std.png" width="50" alt="icon_std">
                                            <img v-else class="rounded" src="@/assets/img/icon_staff.png" width="45" alt="icon_std">
                                        </template>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 class="mb-1 font-thai" v-if="index === 0">Topic : {{ solutionTopic }}</h5>
                                                <h6 v-if="solutiononwercase === item.user" class="mt-0 mb-0 text-capitalize font-thai"><i v-if="index === 0" class="fa fa-user"></i>{{ $keycloak.fullName }}</h6>
                                                <h6 v-else class="mt-0 mb-0 text-capitalize font-thai">[ Support Team ] {{ item.user }} : </h6>
                                            </div>
                                            <small style="font-size:0.7rem;" class="font-en text-small"><i class="fa fa-history" aria-hidden="true"></i>{{ moment(item.created_at).format('LLL') }}</small>
                                        </div>
                                        <hr class="">
                                        <p style="font-size:0.7rem;" class="mt-2 mb-0 font-thai text-muted">
                                            <i :class="{ 'fa fa-question': solutiononwercase === item.user , 'fa fa-reply' : solutiononwercase !== item.user  }"></i>{{ solutiononwercase === item.user ? 'Question / issue' : `Reply` }}
                                        </p>
                                        <p style="font-size:1rem;" class="mt-1 mb-0 font-thai text-justify">
                                            <span class="font-thai">{{ item.message }}</span>
                                        </p> 
                                        <!-- <froalaView class="mt-2" v-model="item.message"></froalaView> -->
                                        <b-link class="font-weight-bold" style="font-size:0.7rem;" variant="light" v-if="item.upload_file !== '' && item.upload_file !== null" target="_blank" :href="item.upload_file" >
                                            <i v-if="getFileExtension(item.upload_file) === 'pdf'" class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                            <i v-else-if="getFileExtension(item.upload_file) === 'docx'" class="fa fa-file-word-o" aria-hidden="true"></i>
                                            <i v-else-if="getFileExtension(item.upload_file) === 'png' || getFileExtension(item.upload_file) === 'jpg' || getFileExtension(item.upload_file) === 'jpeg'" class="fa fa-picture-o" aria-hidden="true"></i>
                                            <i v-else class="fa fa fa-file" aria-hidden="true"></i>
                                            View file .{{ getFileExtension(item.upload_file) }}
                                        </b-link>
                                        <div v-if="getFileExtension(item.upload_file) === 'png' || getFileExtension(item.upload_file) === 'jpg' || getFileExtension(item.upload_file) === 'jpeg'">
                                            <b-img width="50" thumbnail :src="item.upload_file" alt=""></b-img>
                                        </div>
                                    </b-media>
                                </b-card-text>
                            </b-card>
                        </div>
                        <!-- success form -->
                        <div v-if="solutionStaus === 'success'">
                            <div v-if="solutionticketpoint !== null">
                                <h4 style="font-weight:100;" class="mt-5 mb-1 font-thai">
                                    <i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>Point :
                                    <span v-if="solutionticketpoint !== null"> <span v-for="(item, star) in solutionticketpoint" :key="star"><i class="fa fa-star fa-lg mr-2 text-warning" aria-hidden="true"></i></span></span>
                                </h4>
                                <h4 style="font-weight:100;" class="mt-3 mb-0 font-thai">
                                    <i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>Suggestion : {{ solutionticketcomment }}
                                    <!-- <froalaView class="mt-2 ml-5 font-thai" v-model="solutionticketcomment"></froalaView> -->
                                </h4>
                            </div>
                            <div v-else>
                                <b-form-input hidden v-model="formVoteData.idJob"></b-form-input>
                                <label style="font-size:1.2rem;" class="text-dark font-thai mt-2 mb-2"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Suggestion</label>
                                <!-- <froala id="f3" :config="config" v-model="formVoteData.suggestion"></froala> -->
                                <b-form-textarea
                                    v-model="formVoteData.suggestion"
                                    placeholder="Enter something..."
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                                <label style="font-size:1.2rem;" class="text-dark font-thai mt-2 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Point</label>
                                <div class="row">
                                    <div class="col-md-4">
                                        <fieldset class="rating">
                                            <input type="radio" id="star5" name="rating" value="5" /><label class = "full" for="star5" title="5 point"></label>
                                            <input type="radio" id="star4" name="rating" value="4" /><label class = "full" for="star4" title="4 point"></label>
                                            <input type="radio" id="star3" name="rating" value="3" /><label class = "full" for="star3" title="3 point"></label>
                                            <input type="radio" id="star2" name="rating" value="2" /><label class = "full" for="star2" title="2 point"></label>
                                            <input type="radio" id="star1" name="rating" value="1" /><label class = "full" for="star1" title="1 point"></label>
                                        </fieldset>
                                    </div>
                                </div>
                                <b-button style="font-size:1.2rem;" class="text-capitalize mb-3" @click="addVoteTicket" size="sm" block variant="success"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i>Submit Vote Ticket / close</b-button>
                            </div>
                        </div>
                        <!-- wait form  !formUiComment -->
                        <div v-if="solutionStaus === 'wait' || solutionStaus === 'accept'">
                            <b-form-input hidden v-model="formCommentData.idJob"></b-form-input>
                            <label style="font-size:1.2rem;" class="text-dark font-thai mt-3 mb-2"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Question / issue</label>
                            <!-- error chk -->
                            <b-alert v-for="msg in errorMsgs" :key="msg.timestamp" show variant="danger" dismissible>
                                Check : File size upload image max size 10Mb or massege push
                            </b-alert>
                            <!-- <froala id="f2" :config="config" v-model="formCommentData.Comment"></froala> -->
                            <b-form-textarea
                                v-model="formCommentData.Comment"
                                placeholder="Enter something..."
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                            <label style="font-size:1.2rem;" class="text-dark font-thai mt-2 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Attachments (if any)</label>
                            <b-form-group>
                                <b-form-file plain class="mt-2" v-model="formCommentData.file" size="sm"></b-form-file>
                                <label style="font-size:0.7rem;" class="text-dark font-thai mt-0 mb-0">*** Screen-shot of issue (showing the problem, disconnects or failed connections, etc.) <strong>(max 10Mb total)</strong></label>
                            </b-form-group>
                            <div class="row">
                                <!-- <div :class="{'col-md-12': solutionStaus === 'wait' , 'col-md-6' : !formUiComment}" > -->
                                <div class="col-md-12" >
                                    <b-button style="font-size:1rem;" :disabled="!isFormValid" @click="addCommentRequest" size="sm" class="mt-2 mb-2 text-capitalize" block variant="info">
                                        <i class="fa fa-paper-plane" aria-hidden="true"></i>Submit
                                    </b-button>
                                </div>
                                <!--  
                                    <div class="col-md-6" >
                                        <b-button style="font-size:1rem;" v-if="solutionStaus !== 'wait'" @click="CloseFormComment" size="sm" class="mt-2 mb-2 text-capitalize" block variant="warning">
                                            <i class="fa fa-reply mr-1"></i>Back
                                        </b-button>
                                    </div>
                                -->
                            </div>
                        </div>
                        <!-- inprogress form -->
                        <!-- <div v-if="solutionStaus === 'accept' && formUiComment">
                            <div v-if="formUiVote">
                                <b-form-input hidden v-model="formVoteData.idJob"></b-form-input>
                                <label style="font-size:1.2rem;" class="text-dark font-thai mt-2 mb-2"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Suggestion (if any)</label>
                                <b-form-textarea
                                    v-model="formVoteData.suggestion"
                                    placeholder="Enter something..."
                                    rows="3"
                                    max-rows="6"
                                ></b-form-textarea>
                                <label style="font-size:1.2rem;" class="text-dark font-thai mt-2 mb-0"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>Point</label>
                                <div class="row">
                                    <div class="col-md-4">
                                        <fieldset class="rating">
                                            <input type="radio" id="star5" name="rating" value="5" /><label class = "full" for="star5" title="5 point"></label>
                                            <input type="radio" id="star4" name="rating" value="4" /><label class = "full" for="star4" title="4 point"></label>
                                            <input type="radio" id="star3" name="rating" value="3" /><label class = "full" for="star3" title="3 point"></label>
                                            <input type="radio" id="star2" name="rating" value="2" /><label class = "full" for="star2" title="2 point"></label>
                                            <input type="radio" id="star1" name="rating" value="1" /><label class = "full" for="star1" title="1 point"></label>
                                        </fieldset>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <b-button style="font-size:1.2rem;" class="text-capitalize" @click="addCloseTicket" size="sm" block variant="success"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i>Submit Vote Ticket / close</b-button>
                                    </div>
                                    <div class="col-md-6">
                                       <b-button style="font-size:1.2rem;" size="sm" @click="CloseFormVote" class="text-capitalize" block variant="warning"><i class="fa fa-reply mr-1"></i>Back</b-button>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <hr>
                                <h4 class="mt-3 mb-2 text-danger text-capitalize font-weight-bold"><i class="fa fa-chevron-circle-right mr-1" aria-hidden="true"></i>Is your problem resolved ?</h4>
                                <b-button style="font-size:1.2rem;" class="text-capitalize" @click="openFormVote" block variant="success">
                                    <i class="fa fa-check mr-1" aria-hidden="true"></i>Yes
                                </b-button>
                                <b-button style="font-size:1.2rem;" class="text-capitalize" @click="openFormComment" block variant="danger">
                                    <i class="fa fa-times mr-1" aria-hidden="true"></i>No
                                </b-button>
                            </div>
                        </div> -->
                        <!-- inprogress form -->
                    </div>
                </b-card>
                <b-media>
                    <h6 style="font-weight:100" class="text-capitalize mt-0 mb-1 font-en"><i class="fa fa-phone-square" aria-hidden="true"></i> For more inquiries, please contact :</h6>
                        <b-alert show variant="infox">
                            <p style="font-size:0.8rem" class="text-muted font-en">The Admission Office<br>Tel. 0-2700-5000 ext. 4344-4347</p>
                            <p style="font-size:0.8rem" class="text-muted font-en">The Registrar Unit<br>Tel. 0-2700-5000 ext. 4325, 4330-4334, 4336 and 4342</p>
                            <p style="font-size:0.8rem" class="text-muted font-en">The Educational Affairs Section<br>Tel. 0-2700-5000 ext. 4311, 4314 and 4318</p>
                            <p style="font-size:0.8rem" class="text-muted font-en">The Office of Student Affairs<br>Tel. 0-2700-5000 ext. 1115 and 1210</p>
                            <p style="font-size:0.8rem" class="text-muted font-en">The Finance & Accounting Section<br>Tel. 0-2700-5000 ext. 1020, 1322 and 1231</p>
                            <p style="font-size:0.8rem" class="text-muted font-en">Science Division Office<br>Tel. 0-2700-5000 ext. 3517</p>
                            <p style="font-size:0.8rem" class="text-muted text-right mt-0 mb-0"><small>Updated March 23, 2020(2.45 p.m.)</small></p>
                        </b-alert>
                </b-media>
            </div> 
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
    .custom-font-h{
        font-family: 'Nunito', sans-serif;
        font-weight: 100;
    }
    .custom-font-btn{
        font-family: 'Nunito', sans-serif;
        font-weight: bold;
    }
    .alert-danger {
        background-color: #f1d1d1;
        color: #B33C12;
    }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .font-en{ font-family: 'Kanit', sans-serif; }
    .f-0.75{
        font-size: 0.75rem;
        font-weight: 100;
    }
    .f-0.7{
        font-size: 0.7rem;
        font-weight: 100;
    }
    .card {
        border-radius: 5px;
        box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
        background-color: #FFFFFF;
        color: #252422;
        margin-bottom: 20px;
        position: relative;
        z-index: 1;
        border: none;
    }
    .bordercolorCustom{ border-left: 20px solid #8cc1f9; border-right: 3px solid #8cc1f9; }
    .border-s{ border-left: 5px solid #41B883; }
    .border-w{ border-left: 5px solid #f7bd2f; }
    .alert-infox { background-color: #eaeaea; color: #000000; }
    #style-4::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }
    #style-4::-webkit-scrollbar
    {
        width: 5px;
        background-color: #F5F5F5;
    }
    #style-4::-webkit-scrollbar-thumb
    {
        background-color: #bdbdbd;
        border: 1px solid #bdbdbd;
    }
    // 
    #style-5::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #ffffff;
    }
    #style-5::-webkit-scrollbar
    {
        width: 3px;
        background-color: #F5F5F5;
    }
    #style-5::-webkit-scrollbar-thumb
    {
        background-color: #bdbdbd;
        border: 1px solid #bdbdbd;
    }
    // 34597b 3578E5
    .alert-infomsg {  background-color: #34597b; color: #ffffff; }
    // rating vote
    /****** Style Star Rating Widget *****/
    .rating { 
        border: none;
        float: right;
    }
    .rating > input { display: none; } 
    .rating > label:before { 
        margin: 5px;
        font-size: 3em;
        font-family: FontAwesome;
        display: inline-block;
        content: "\f005";
    }
    .rating > .half:before { 
        content: "\f089";
        position: absolute;
    }
    .rating > label { 
        color: #ddd; 
        float: right; 
    }
    /***** CSS Magic to Highlight Stars on Hover *****/
    .rating > input:checked ~ label, /* show gold star when clicked */
    .rating:not(:checked) > label:hover, /* hover current star */
    .rating:not(:checked) > label:hover ~ label {  color: #FFD700;  } /* hover previous stars in list */
    .rating > input:checked + label:hover, /* hover current star when changing rating */
    .rating > input:checked ~ label:hover,
    .rating > label:hover ~ input:checked ~ label, /* lighten current selection */
    .rating > input:checked ~ label:hover ~ label {  color: #FFED85;  } 
</style>

<script>
    // import VueFroala from 'vue-froala-wysiwyg';
    const formProblem = {
        titleProblem:'',
        descriptionProblem:'',
        typeProblem:'',
        phoneContact:'',
        mailContact:'',
    }
    const formComment = {
        idJob:'',
        Comment:'',
        file:null,
    }
    const formVote = {
        suggestion:'',
        idJob:'',
    }
    // import FroalaEditor from 'froala-editor/js/froala_editor.min'
    export default {
        components: {},
        data() {
            return {
                errorMsgs: [],
                // config: {
                //     imageUpload: true,
                //     imageMaxSize: 1024 * 1024 * 0.5,
                //     autoDestroy: true,
                //     attribution: false,
                //     toolbarButtons : {
                //         'moreText': {
                //             'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
                //         },
                //         'moreParagraph': {
                //             'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
                //         },
                //         'moreRich': {
                //             'buttons': ['insertLink', 'insertImage', 'insertVideo', 'insertTable','specialCharacters', 'embedly'],
                //             'buttonsVisible': 6
                //         },
                //         'moreMisc': {
                //             'buttons': ['undo', 'redo', 'help'],
                //             'align': 'right',
                //             'buttonsVisible': 3
                //         }
                //     },
                //     events: {
                //         "image.beforeUpload": function(files) {
                //             var editor = this;
                //             if (files.length) {
                //                 // Create a File Reader.
                //                 var reader = new FileReader();
                //                 // Set the reader to insert images when they are loaded.
                //                 reader.onload = function(e) {
                //                 var result = e.target.result;
                //                     editor.image.insert(result, null, null, editor.image.get());
                //                 };
                //                 // Read image as base64.
                //                 reader.readAsDataURL(files[0]);
                //             }
                //             editor.popups.hideAll();
                //             // Stop default upload chain.
                //             return false;
                //         },
                //     }
                // },
                chkCloseTicket:true,
                formUiVote:false,
                formUiComment:true,
                view:false,
                dataObj: {},
                itemsWait: [],
                itemsSuccess: [],
                itemsCancel: [],
                // 
                solutionId:'',
                solutionStaus:'',
                solutionType:'',
                solutionTopic:'',
                solutionDetail:'',
                solutionMsg:'',
                solutionPhone:'',
                solutionMail:'',
                solutiononwercase:'',
                // 
                contentShow: false,
                window: {
                    width: 0,
                    height: 0
                },
                MaxScale:'Monitor',
                fieldsWait: [
                    { 
                        key: 'list', 
                        label: '',
                        thStyle: 
                        { 
                            backgroundColor: '#fff',
                            border:'0px solid #fff',
                            width:'100%',
                            height:'1%'
                        } 
                    },
                ],
                fieldsSuccess: [
                    { 
                        key: 'list', 
                        label: '',
                        thStyle: 
                        { 
                            backgroundColor: '#fff',
                            fontSize:'0.1rem',
                            border:'0px solid #fff',
                            width:'100%',
                            height:'1%'
                        }
                    },
                ],
                EditForm:false,
                optionsSelectProblem:[],
                formData: Object.assign({}, formProblem),
                formCommentData: Object.assign({}, formComment),
                formVoteData: Object.assign({}, formVote),
                dataComment:[],
            }
        },
        computed: {
            isFormValid(){
                return this.formCommentData.Comment !== '';
            },
        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        mounted(){
            this.checkMsgWhoAmi()
            this.loadDataRequest()
            this.optionApi()
        },
        methods: {
            isEmpty(obj) {
                for(var prop in obj) {
                    if(obj.hasOwnProperty(prop))
                        return false;
                }
                return true;
            },
            openFormComment(){
                this.formUiComment = !this.formUiComment
            },
            CloseFormComment(){
                this.formUiComment = !this.formUiComment
            },
            openFormVote(){
                this.formUiVote = true
            },
            CloseFormVote(){
                this.formUiVote = false
            },
            checkMsgWhoAmi(){
                var count = 0
                var arr = ['faculty','staff','student']
                for (let index = 0; index < this.$store.state.permit.RulesUser.roles.length; index++) {
                    // console.log(this.$route.meta.permitC.includes(this.$store.state.permit.RulesUser.roles[index]))
                    if(arr.includes(this.$store.state.permit.RulesUser.roles[index])){
                        count++
                    }
                }
                // console.log(count)
                if(count == 0){
                    this.$router.push("/accountpermit").catch(err => {})
                }else{
                    this.view = true
                }
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                if(this.window.width <= 1200){
                    this.MaxScale = 'miniMonitor'
                    this.contentShow = false
                    // 
                        this.solutionId = ''
                        this.solutionStaus = ''
                        this.solutionType = ''
                        this.solutionTopic = ''
                        this.solutionDetail = ''
                        this.solutionMsg = ''
                        this.solutionPhone = ''
                        this.solutionMail = ''
                        this.formData = Object.assign({}, formProblem)
                        this.EditForm = false
                    // 
                }else{
                    this.MaxScale = 'Monitor'
                }
            },
            zeroPad(num) {
                return num.toString().padStart(4, "0");
            },
            openAddRequest() {
                // this.$router.push('/formrequest')
                this.$router.push({
                    name:"Create new query",
                    query: { 
                        category: 0,
                    }, 
                }).catch(err => {})
            },
            reloadCloseModal(value){
                this.loadDataRequest()
                this.$root.$emit('bv::hide::modal', 'my-modal-request')
            },
            async loadDataRequest(){
                this.itemsWait = []
                this.itemsSuccess = []
                // 
                    // this.solutionId = ''
                    // this.solutionStaus = ''
                    // this.solutionType = ''
                    // this.solutionTopic = ''
                    // this.solutionDetail = ''
                    // this.solutionMsg = ''
                    // this.solutionPhone = ''
                    // this.solutionMail = ''
                    this.formData = Object.assign({}, formProblem)
                    this.EditForm = false
                //
                try {
                    const res = await this.$http.get('/ticket/me/')
                    // waitjob
                    this.itemsWait = res.data.filter( acceptJob => {
                        return acceptJob.status === 'accept' || acceptJob.status === 'wait'
                    }).map(itemAccept => {
                        return {
                            'no':Number(itemAccept.id),
                            'listService': itemAccept.topic, 
                            'description': itemAccept.message,
                            'jobtype': itemAccept.ticket_type_detail,
                            'status':itemAccept.status,
                            'onwercase':itemAccept.onwercase,
                            'jobpoint':itemAccept.ticketpoint,
                            'created_at':itemAccept.created_at,
                            'phone':itemAccept.contact_phone,
                            'mail':itemAccept.contact_mail,
                            'helpdesk_type':itemAccept.ticket_type,
                            'user': itemAccept.user,
                            'ticketcomment': itemAccept.ticketcomment,
                            'ticketpoint': itemAccept.ticketpoint,
                            'user_read':itemAccept.user_read
                        }
                    })
                    // sort
                    this.itemsWait.sort((a, b) =>{ return b.no - a.no; });
                    // successjob
                    this.itemsSuccess = res.data.filter( successJob => {
                        return successJob.status === 'success' || successJob.status === 'cancel'
                    }).map(item => {
                        return {
                            'no':Number(item.id),
                            'listService': item.topic, 
                            'description': item.message,
                            'jobtype': item.ticket_type_detail,
                            'status':item.status,
                            'onwercase':item.onwercase,
                            'jobpoint':item.ticketpoint,
                            'created_at':item.created_at,
                            'phone':item.contact_phone,
                            'mail':item.contact_mail,
                            'helpdesk_type':item.ticket_type,
                            'user': item.user,
                            'ticketcomment': item.ticketcomment,
                            'ticketpoint': item.ticketpoint,
                            'user_read':item.user_read
                        }
                    })
                    // sort
                    this.itemsSuccess.sort((c, d) =>{ return d.no - c.no; });
                } catch (error) {}
            },
            async getMassegeComment(JobidView){
                this.dataComment = []
                try {
                    const res = await this.$http.get(`/ticket/msg/pull/${JobidView}/`)
                    // console.log(res.data)dataComment
                    this.dataComment = res.data.map(item => {
                        return {
                            'id':Number(item.id),
                            'created_at': item.created_at, 
                            'message': item.message,
                            'ticket': item.ticket,
                            'upload_file':item.upload_file,
                            'user':item.user,
                        }
                    })
                    this.scrollToEnd()
                } catch (error) {}
            },
            showSolution(objItem){
                if(objItem.length !== 0){
                    // get
                        this.formUiVote = false
                        this.formUiComment = true
                        this.formVoteData.idJob = objItem[0].no
                        this.formCommentData.idJob = objItem[0].no
                        this.getMassegeComment(objItem[0].no)
                    // get
                    if(this.window.width <= 1200){
                        //moblie  Width: 444, Height: 736 , ipad  Width: 1024, Height: 1366
                        this.$router.push({
                            name:"Contentsolution",
                            params: { 
                                id: objItem[0].no,
                                Staus: objItem[0].status,
                                Toppic: objItem[0].listService,
                                description: objItem[0].description,
                                solution: objItem[0].solution,
                                Phone: objItem[0].phone,
                                Mail: objItem[0].mail,
                                Type: objItem[0].helpdesk_type,
                                onwercase: objItem[0].user,
                                ticketcomment: objItem[0].ticketcomment,
                                ticketpoint: objItem[0].ticketpoint,
                            }, 
                        }).catch(err => {})
                    }else{
                        //full  Width: 1920, Height: 1080
                        this.contentShow = true
                        this.solutionId = objItem[0].no
                        this.solutionStaus = objItem[0].status
                        this.solutionTopic = objItem[0].listService
                        this.solutionMsg = objItem[0].description
                        this.solutionDetail = objItem[0].solution
                        this.solutionPhone = objItem[0].phone
                        this.solutionMail = objItem[0].mail
                        this.solutionType = objItem[0].helpdesk_type
                        this.solutiononwercase  = objItem[0].user,
                        this.solutionticketcomment = objItem[0].ticketcomment,
                        this.solutionticketpoint = objItem[0].ticketpoint
                    }
                }
                this.loadDataRequest()
            },
            onRowSelected(items) {
                this.formData = Object.assign({}, formProblem)
                // this.formCommentData =  Object.assign({}, formComment)
                // this.formVoteData = Object.assign({}, formVote)
                this.EditForm = false
                this.$refs.selectableTable2.clearSelected()
                this.showSolution(items)
            },
            onRowSelected_2(items) {
                this.formData = Object.assign({}, formProblem)
                // this.formCommentData =  Object.assign({}, formComment)
                // this.formVoteData = Object.assign({}, formVote)
                this.EditForm = false
                this.$refs.selectableTable1.clearSelected()
                this.showSolution(items)
            },
            async cancelCase(Jobid){
                const response = await this.$http.delete(`/ticket/remove/${Jobid}/`,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                if(response.status === 200){
                    // 
                        this.contentShow = false
                        this.solutionId = ''
                        this.solutionStaus = ''
                        this.solutionType = ''
                        this.solutionTopic = ''
                        this.solutionDetail = ''
                        this.solutionMsg = ''
                        this.solutionPhone = ''
                        this.solutionMail = ''
                    // 
                }
                this.loadDataRequest()
            },
            async optionApi(){
                try {
                    this.optionsSelectProblem = []
                    const res = await this.$http.get('/ticket/type/')
                    this.optionsSelectProblem =  res.data.map(item => {
                        return {
                            'value':item.id,
                            'text': item.detail,
                        }
                    })
                    this.optionsSelectProblem
                } catch (error) {
                    this.output = error
                }
            },
            changeEditForm(){
                this.EditForm = true
                this.formData.descriptionProblem = this.solutionMsg
                this.formData.typeProblem = this.solutionType
                this.formData.phoneContact = this.solutionPhone
                this.formData.mailContact = this.solutionMail
            },
            async updateTicketData(Jobid){
                const sendDataProblem = new FormData()
                sendDataProblem.append('message', this.formData.descriptionProblem)
                sendDataProblem.append('ticket_type', this.formData.typeProblem)
                sendDataProblem.append('contact_phone', this.formData.phoneContact)
                sendDataProblem.append('contact_mail', this.formData.mailContact)
                try {
                    const response = await this.$http.patch(`/ticket/updated/${Jobid}/`,
                        sendDataProblem,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        this.loadDataRequest()
                        this.solutionId = response.data.id
                        this.solutionTopic = response.data.topic
                        this.solutionMsg = response.data.message
                    }
                } catch (error) {
                    this.output = error
                }
            },
            async addCommentRequest(){
                try {
                    const sendMsgComment = new FormData()
                    // sendMsgComment.append('id', this.formCommentData.idJob)
                    sendMsgComment.append('msg_type', 'ask')
                    sendMsgComment.append('message', this.formCommentData.Comment)
                    if(this.formCommentData.file !== null){
                        sendMsgComment.append('upload_file', this.formCommentData.file)
                    }else{
                        sendMsgComment.append('upload_file', null)
                    }
                    const resCreateMsg = await this.$http.post(`/ticket/msg/push/${this.formCommentData.idJob}/`, sendMsgComment,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(resCreateMsg.status === 201){
                        this.formCommentData =  Object.assign({}, formComment)
                        // get
                            this.formCommentData.idJob = resCreateMsg.data.ticket
                            this.formVoteData.idJob = resCreateMsg.data.ticket
                            this.getMassegeComment(resCreateMsg.data.ticket)
                        // get
                    }else {
                        throw { resCreateMsg }
                    }
                } catch (error) {
                    this.errorMsgs.push({
                        timestamp: new Date().getTime(),
                        msg: error,
                    });
                    if (this.errorMsgs.length > 1) this.errorMsgs.shift()
                }
            },
            scrollToEnd() {},
            getFileExtension(filename)
            {
                var ext = /^.+\.([^.]+)$/.exec(filename);
                return ext == null ? "" : ext[1].toLowerCase();
            },
            async addCloseTicket(){
                try {
                    // upstatust
                    const closeJob = await this.$http.patch(`/ticket/close/${this.formVoteData.idJob}/`, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if (closeJob.status === 200) {
                        // return true
                        this.addVoteTicket()
                    }
                } catch (error) {
                    return false
                }
            },
            async addVoteTicket(){
                try {
                    const sendVote = new FormData()
                    if(document.querySelector('input[name=rating]:checked') !== null){
                        sendVote.append('ticketcomment', this.formVoteData.suggestion)
                        sendVote.append('ticketpoint',document.querySelector('input[name=rating]:checked').value)
                    }else{
                        sendVote.append('ticketcomment', this.formVoteData.suggestion)
                        sendVote.append('ticketpoint',0)
                    }
                    // for (var value of sendVote.values()) {
                    //     console.log(value); 
                    // }
                    const resVote = await this.$http.patch(`/ticket/vote/${this.formVoteData.idJob}/`, sendVote,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(resVote.status === 200){
                        this.formVoteData = Object.assign({}, formVote)
                        this.formUiVote = false
                        this.formUiComment = true
                        this.solutionStaus = 'success'
                        this.solutionticketcomment = resVote.data.ticketcomment
                        this.solutionticketpoint = resVote.data.ticketpoint
                        this.loadDataRequest()
                    }
                } catch (error) {}
            }
        }
    }
</script>